import { Pipe, PipeTransform } from "@angular/core";
import { OOMenuItem } from "../models/oo-menu-item";

@Pipe({ name: "appTagFilter" })
export class TagFilterPipe implements PipeTransform {
	/**
	 * Transform
	 *
	 * @param {any[]} items
	 * @param {string} searchText
	 * @returns {any[]}
	 */
	transform(items: OOMenuItem[], tags: string[]): any[] {
		if (!items) {
			return [];
		}
		if (!tags || tags.length === 0) {
			return items;
		}

		return items.filter((item) => {
			const t = item.OOMenuItemTags.filter((i) => tags.includes(i.tagKey));
			if (t.length > 0) {
				return t;
			}
		});
	}
}
